import {makeStyles} from "@material-ui/styles";
import {getCMSSettings} from "tools/cmsBlockSettings";
import Link from "next/link";
import { useEffect, useState } from 'react';

const useStyles = makeStyles((theme) => {
	return {
		wrapper: {
			margin: '0',
		},
		title: {
			color: theme.palette.primary.lowlight,
			textAlign: 'center'
		},
		list: {
			padding: 0,
			display: 'flex',
			flexWrap: 'wrap',
			gap: '10px',
			justifyContent: 'center',
			[theme.breakpoints.down('xs')]: {
				gap: '5px',
				justifyContent: 'space-around',
			},
			[theme.breakpoints.up('lg')]: {
				justifyContent: 'space-between',
			},
		},
		listItem: {
			display: 'flex',
			flexGrow: '1',
			flexBasis: '185px',
			maxWidth: '50%',
			borderRadius: 0,
			overflow: 'hidden',
			alignItems: 'top',
			[theme.breakpoints.down('xs')]: {
				flexBasis: '170px',
				maxWidth: '100%',
			},
			[theme.breakpoints.up('md')]: {
				maxWidth: '166px',
				flexBasis: '25%',
			},
			[theme.breakpoints.up('lg')]: {
				maxWidth: '250px',
				flexBasis: '10%',
			},
			'& a': {
				display: 'inline-flex',
				flexDirection: 'column',
				gap: '5px',
				lineHeight: '25px',
				fontSize: '14px',
				letterSpacing: 0.5,
				whiteSpace: 'nowrap',
				textDecoration: 'none',
				width: '100%',
				'&:hover': {
					textDecoration: 'underline'
				},
				[theme.breakpoints.down('xs')]: {
					fontSize: 13
				},

				'& img': {
					width: '100%',
					aspectRatio: '1 / 1.08',
					objectFit: 'cover',
					borderRadius: '15px',
					padding: '5px 5px 0',
					'&:hover': {
						opacity: 0.8
					},
					[theme.breakpoints.down('xs')]: {
						padding: 0,
					},
				},
				'& span': {
					textAlign: 'center',
					fontWeight: 600,
					letterSpacing: '2px',
					padding: '10px 5px',
					borderRadius: 1,
					border: '1px solid rgba(0,0,0,0.1)',
					color: theme.palette.primary.color,
					backgroundColor: theme.palette.primary.background,
					lineHeight: 1,
					[theme.breakpoints.up('xs')]: {
						padding: '15px 10px',
					},
				},
				'& img + span': {
					borderColor: 'transparent'
				}
			}
		},
	}
}, {name: 'CategoryNavigation'});

export default function FrontpageBarker({ block }) {
	const classes = useStyles();
	const CMSContent = block.slots[0]?.config;
	function renderListItem(item, index) {
		const url = item?.categorySlug ? '/' + item.categorySlug : item.url;

        return (
            <li className={classes.listItem} key={'category-menu-item-' + index}>
                <Link href={url}>
                    <a style={{
						color: CMSContent?.textColor?.value,
					}}>
						{ item?.media?.value &&
                        <img loading="lazy" src={item?.media?.value} alt={''} />
						}
                        <span style={{
                                color: CMSContent?.textColor?.value,
                                backgroundColor: CMSContent?.backgroundColor?.value,
                            }}>
                            {item?.title}
                        </span>
                    </a>
                </Link>
            </li>
        );
    }

	return (
        <div className={classes.wrapper}>
            {CMSContent.heading && <h2 className={classes.title}>{CMSContent.heading.value}</h2>}
            {CMSContent.entries.value.length > 0 && (
                <nav aria-label={'selected categories'}>
                    <ul className={classes.list}>
                        {CMSContent.entries.value.map((item, index) => renderListItem(item, index))}
                    </ul>
                </nav>
            )}
        </div>
    );
}
